import React from 'react'
import DisplayUpdateTime from 'ui/DisplayUpdateTime'
import { DataTableRowActions } from './data-table-row-action'
import {
  columnCover,
  columnName,
  columnSku,
  columnTags,
} from 'components/template-data-table-column'

export const columns = [
  {
    header: '#',
    cell: ({ row }) => row.index + 1,
  },
  columnCover,
  columnName,
  columnTags,
  columnSku,
  {
    header: 'CreateTime',
    accessorKey: 'createTime',
    cell: ({ row }) => (
      <DisplayUpdateTime updateTime={row.original.createTime} />
    ),
  },
  {
    header: 'Actions',
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
]
